import moment from 'moment-timezone';
import { AMOUNT_DAYS_OF_A_MONTH } from './constants';

export const DATE_TIME_FORMAT = {
  DOB: 'MMM DD, YYYY',
  APPOINTMENT_DATE: 'YYYY-MM-DD',
  HH_MM_SS: 'HH:mm:ss',
  MMM_DD_YYYY: 'MMM DD, YYYY',
  HH_MM_A: 'hh:mm A',
  DEFAULT: 'YYYY-MM-DDTHH:mm:ssZ',
};

export const datetimeFormat = (params: {
  dateString: string;
  format?: string | string[];
  pattern: string;
  timezone?: string;
}) => {
  if (!params.dateString) {
    return '';
  }

  const { dateString, pattern, format, timezone } = params;
  const dateFormat = timezone
    ? moment(dateString, format || '')
        .tz(timezone)
        .format(pattern)
    : moment(dateString, format || '').format(pattern);

  return dateFormat;
};

export const hour12Format = (params: { value: string; format: string }) => {
  const { value, format } = params;

  const hourFormat = moment(
    `01-01-1991,  ${value}`,
    `DD-MM-YYYY, ${format}`
  ).format('LT');
  return hourFormat;
};

export const parseDateStringWithoutAffectTz = (
  dateString: string,
  format: string,
  timezone: string
) => moment.tz(dateString, format, timezone);

export const formatCurrentDateByTz = (timezone: string) => {
  return moment().tz(timezone).format('YYYY-MM-DD');
};

export const getBufferdTimeString = (time: string, minutes: number) => {
  const buffered = moment(time, 'HH:mm:ss')
    .add(minutes, 'minutes')
    .format('HH:mm:ss');
  return buffered;
};

export const getCurrentTimeString = (timezone: string) => {
  return moment().tz(timezone).format('HH:mm:ss');
};

export const convertMinutesIntoHoursOfDay = (params: {
  minutes: number;
  format: string;
}) => {
  const { minutes, format } = params;
  const duration = moment.duration(minutes, 'minutes');
  const hour = duration.hours();
  const minute = duration.minutes();

  return moment(`${hour}:${minute}`, 'H:m').format(format);
};

export const isNextMonth = (date: string, currentDate: string) => {
  return moment(date, 'YYYY-MM-DD').isAfter(
    moment(currentDate, 'YYYY-MM-DD'),
    'months'
  );
};

export const isPastMonth = (date: string, currentDate: string) => {
  return moment(date, 'YYYY-MM-DD').isBefore(
    moment(currentDate, 'YYYY-MM-DD'),
    'months'
  );
};

export const formatWorkingHour = (
  { fromTime, toTime }: { fromTime: string; toTime: string },
  newFormat: string
) => {
  const fromTimeFormatted = moment(fromTime, 'HH:mm:ss').format(newFormat);
  const toTimeFormatted = moment(toTime, 'HH:mm:ss').format(newFormat);

  return `${fromTimeFormatted} - ${toTimeFormatted}`;
};

export const convertToDate = (dateString: string | Date) => {
  if (moment(dateString, 'YYYY-MM-DD', true).isValid()) {
    return moment(dateString, 'YYYY-MM-DD').toDate();
  }

  return moment(dateString).toDate();
};

export const formatDateTimeWithoutEffectTz = (
  date: string,
  oldFormat: string,
  newFormat: string
) => moment.parseZone(date, oldFormat).format(newFormat);

export const getRangeDateFrom = (
  startDate: string,
  amountDays: number
): string[] => {
  return (Array.from({ length: amountDays }) as undefined[]).reduce(
    (accumulator: string[], _, index: number) => {
      const date = moment(startDate, 'YYYY-MM-DD')
        .add(index + 1, 'days')
        .format('YYYY-MM-DD');
      accumulator.push(date);
      return accumulator;
    },
    [startDate]
  );
};

export const getAllDatesWithinYearFromDate = (date: string) => {
  const AMOUNT_DAYS_OF_A_YEAR = AMOUNT_DAYS_OF_A_MONTH * 12;

  const dateRangesWithinAYear = getRangeDateFrom(date, AMOUNT_DAYS_OF_A_YEAR);

  return dateRangesWithinAYear;
};

export const numberOfDatesBetween = (
  date1: { value: string; format: string },
  date2: { value: string; format: string }
) => {
  return Math.abs(
    moment(date1.value, date1.format).diff(
      moment(date2.value, date2.format),
      'days'
    )
  );
};
